
$(".productDetailHead").click(function () {
    var data_target = $(this).data('target');
    if (data_target) {

        $('.mobile-pdp-tab').css("bottom", "-200%");
        var container_id = '#' + data_target;
        $('body').addClass('pdp-tab-mobile-active');
        $('html').addClass('pdp-tab-mobile-active');
        $('body').append('<div class="modal-backdrop fade show"></div>');
        $(container_id).css("bottom", "0px");
        //$(container_id).css("left", "30px");

    }
});
$(".close-button").click(function () {
    // console.log("start")
    $('.mobile-pdp-tab').css("bottom", "-200%");
    $('.modal-backdrop').remove();
    $('body').removeClass('pdp-tab-mobile-active');
    $('html').removeClass('pdp-tab-mobile-active');
});

window.onclick = function (e) {
  if (e.target.classList.contains("modal-backdrop")) {
    $(".mobile-pdp-tab").css("bottom", "-200%");
    $(".modal-backdrop").remove();
    $("body").removeClass("pdp-tab-mobile-active");
    $("html").removeClass("pdp-tab-mobile-active");
    $("#mobile-add-to-cart-modal").removeClass("opened");

}
};

$(".mobile-pdp-tab .heading .close button").click(function () {
    // console.log("finish")
    $(this).closest('.mobile-pdp-tab').css("bottom", "-200%");
    $('.modal-backdrop').remove();
    $('body').removeClass('pdp-tab-mobile-active');
    $('html').removeClass('pdp-tab-mobile-active');
});


$(".buy-options .item").click(function () {
    $('.buy-options .item').removeClass("active");
    $(this).addClass("active");
    $(this).find('input').prop("checked", true);
});

$(".extra-packages .item").click(function () {
    $(this).find('input').prop("checked", true);
});

$(".see-all-link, .all-reviews-desktop").click(function () {
    $('#review-tab').addClass('tab-active');
    $('#technical-spec-tab').removeClass('tab-active');
    $('#refund-tab').removeClass('tab-active');
    $('#product-desc-tab').removeClass('tab-active');
    $('#judgeme_product_reviews').removeClass('tab-active');
    $('.product-description-content').addClass('d-none');
    $('.product-description-content').removeClass('d-block');
    $('.technical-specification-content').addClass('d-none');
    $('.technical-specification-content').removeClass('d-block');
    $('.refund-content').addClass('d-none');
    $('.refund-content').removeClass('d-block');
    $('.reviews-content').addClass('d-block');
});


const login_true=document.getElementById("myLogin");
 $('.mobileYorumlarClick').click(function() {
    
        $('body').addClass('pdp-tab-mobile-active');
        $('html').addClass('pdp-tab-mobile-active');
       // $('body').append('<div class="modal-backdrop fade show"></div>');
        $('#mobile-yorumlar').css("bottom","0px");
        const spr_action=document.querySelector('.jdgm-rev-widg__header');
        if(spr_action){
            if(login_true.classList.contains('login-true')){
                spr_action.classList.add('d-block');
            }
        }
        
    
    
 });

$('.variantImgs li').click(function () {
    $('.variantImgs li').removeClass('active');
    $(this).addClass('active');
});

$(document).ready(function () {
    $('.buy-options .item:first-child').addClass("active");
    $('.buy-options .item:first-child').find('input').prop("checked", true);
});

$(".open-added-basket-modal").click(function(){
    $("#mainAddToCartButton").trigger("click");
    $(".desktop-pdp-tab").hide();
});
// Slider: Badge
const swiperProduct = new Swiper('.swiper-badge', {
    direction: 'horizontal',
    loop: false,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true
    },
    slidesPerView: 5,
    spaceBetween: 20,
    breakpoints: {
        320: {
            slidesPerView: 2.5
        },
        767: {
            slidesPerView: 4
        },
        1024: {
            slidesPerView: 4
        },
        1280: {
            slidesPerView: 4
        }
    },
    resizeObserver: true
});

let productDescription = document.getElementById("product-description");
let technicalSpecifications = document.getElementById("technical-specifications");
let reviews = document.getElementById("reviews");
let myReviews = document.getElementById("judgeme_product_reviews");

let refund = document.getElementById("refund-content");
let productDescTab = document.getElementById("product-desc-tab");
let technicalSpecTab = document.getElementById("technical-spec-tab");
let refundTab = document.getElementById("refund-tab");
let reviewTab = document.getElementById("reviews-tab");


productDescTab.addEventListener("click", function () {
    productDescription.classList.remove("d-none")
    productDescription.classList.add("d-block");
    technicalSpecifications.classList.remove("d-block");
    technicalSpecifications.classList.add("d-none");

    myReviews.classList.add('d-none');
    myReviews.classList.remove("d-flex");
    if(reviews){
        reviews.classList.remove("d-block");
        reviews.classList.add("d-none");
    }
    refund.classList.remove("d-block");
    refund.classList.add("d-none");
    productDescTab.classList.add("tab-active");
    refundTab.classList.remove("tab-active");
    technicalSpecTab.classList.remove("tab-active");
    reviewTab.classList.remove("tab-active");
})

technicalSpecTab.addEventListener("click", function () {
    technicalSpecifications.classList.remove("d-none");
    technicalSpecifications.classList.add("d-block");
    productDescription.classList.remove("d-block");
    productDescription.classList.add("d-none");
    refund.classList.remove("d-block");
    refund.classList.add("d-none");
    
    myReviews.classList.add('d-none');
    myReviews.classList.remove("d-flex");
    technicalSpecTab.classList.add("tab-active");
    refundTab.classList.remove("tab-active");
    productDescTab.classList.remove("tab-active");
    reviewTab.classList.remove("tab-active");
})

refundTab.addEventListener("click", function () {
    productDescription.classList.remove("d-block");
    productDescription.classList.add("d-none");
    technicalSpecifications.classList.remove("d-block");
    technicalSpecifications.classList.add("d-none");
    refund.classList.remove("d-none");
    refund.classList.add("d-block");
    
    myReviews.classList.add('d-none');
    myReviews.classList.remove("d-flex");
    refundTab.classList.add("tab-active");
    reviewTab.classList.remove("tab-active");
    productDescTab.classList.remove("tab-active");
    technicalSpecTab.classList.remove("tab-active");
})
reviewTab.addEventListener("click",function(){
    productDescription.classList.remove("d-block");
    productDescription.classList.add("d-none");
    technicalSpecifications.classList.remove("d-block");
    technicalSpecifications.classList.add("d-none");
    refund.classList.remove("d-block");
    refund.classList.add("d-none");
    
    myReviews.classList.add('d-flex');
    myReviews.classList.remove("d-none");
    refundTab.classList.remove("tab-active");
    reviewTab.classList.remove("tab-active");
    productDescTab.classList.remove("tab-active");
    technicalSpecTab.classList.remove("tab-active");
})



    

